import React, { useEffect, useRef } from 'react';
import { FiMinus, FiPlus, FiMoreVertical } from 'react-icons/fi';
import ColorPalette from './ColorPalette.jsx';

const NoteHeader = function({
  moveHandleProps,
  title,
  onTitleChange,
  selected,
  color,
  onColorChange,
  onPaste,
  minimized,
  onToggleMinimized,
  onDelete
}) {
  const titleRef = useRef(null);
  const menuRef = useRef(null);

  useEffect(() => {
    const closeOutside = function(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) menuRef.current.open = false;
    };

    document.addEventListener('pointerdown', closeOutside);

    return () => document.removeEventListener('pointerdown', closeOutside);
  }, []);

  const runAction = function(action) {
    menuRef.current.open = false;
    action();
  };

  return <header className='noteHead h'>
      <div className='noteTitleField'>
        <span className='noteTitleMeasure' aria-hidden='true'>{title || 'note'}</span>
      <input
        ref={titleRef}
        className='noteTitle'
        aria-label='note title'
        placeholder='note'
        value={title}
        onChange={event => onTitleChange(event.target.value)}
      />
      </div>
      <button
        className='dragHandle'
        aria-label='move note; use arrow keys when focused'
        title='drag to move · arrow keys to nudge'
        {...moveHandleProps}
      />
      <button
        className='minimizeNoteButton'
        aria-label={minimized ? 'expand note' : 'minimize note'}
        aria-expanded={!minimized}
        title={minimized ? 'expand note' : 'minimize note'}
        onClick={onToggleMinimized}
      >
        {minimized ? <FiPlus size={12} aria-hidden='true' /> : <FiMinus size={12} aria-hidden='true' />}
      </button>
      <button
        className='deleteNoteButton'
        aria-label='delete note'
        title='delete note'
        onClick={onDelete}
      >
        <span aria-hidden='true' />
      </button>
      {selected && <details
        className='noteMenu'
        ref={menuRef}
        onKeyDown={event => {
          if (event.key === 'Escape') {
            menuRef.current.open = false;
            menuRef.current.querySelector('summary').focus();
            event.stopPropagation();
          }
        }}
      >
          <summary aria-label='note options' title='note options'>
            <FiMoreVertical size={15} aria-hidden='true' />
          </summary>
          <div className='noteMenuPanel'>
            <button onClick={() => runAction(() => {
          titleRef.current.focus();
          titleRef.current.select();
        })}>rename</button>
            <button onClick={() => runAction(onPaste)}>paste</button>
            <div className='noteMenuColors'>
              <span>color</span>
              <ColorPalette color={color} onChange={onColorChange} label='note color' />
            </div>
            <button onClick={() => runAction(onDelete)}>delete note</button>
          </div>
        </details>}
    </header>;
};

export default NoteHeader;
